module.exports = __webpack_public_path__ + "img/Frame-50.abfa5c97.svg";